/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React,{useState,useEffect, useRef} from 'react'
import { FormControl, MenuItem, FormHelperText,InputLabel } from '@material-ui/core';
// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import Selects from '@mui/material/Select';
import { FormContext } from '../Component/Forms/FormContext';
import elementValidate from '../Component/validation';
import  { useContext } from  'react';
import { APIGET } from '../services/APIServices';
import SubTable from "./SubTable";
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
//Import master Data Context
import { debounce } from 'lodash';
import { MasterContext } from '../services/MasterContext'; 
 
export default function Select(props) {
  const {useStyle} = ThemeControls;
  const classes = useStyle();
  const [attr,setAttr] = React.useState();
  const {id, field_type,field_apipath,field_history,fields, field_disabled_Edit,field_unique,field_id, field_label, field_placeholder,field_disabled, field_value,field_option_src, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
  let {masterData} = React.useContext(MasterContext);
  const { handleChange } = useContext(FormContext);
  const [fieldDisable, setFieldDisable]= useState(field_disabled);
    const [fieldOptions,setFieldOptions] = React.useState(field_options);
    // const [items, setItems] = useState([]);
    // const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const apiContextObj = {};
    if(field_apipath){
    apiContextObj.apiContext=field_apipath.apiContext;
    apiContextObj.type=field_apipath.type;
    apiContextObj.id=field_apipath.id;
    apiContextObj.action=field_apipath.action;
    }
    const debouncedGetOptions = debounce(getOptions, 300);
    //console.log(field_value)
    async function getOptions(props) {
      try{
        if(props.field_option_src_context){
           
            if(props.field_option_check_local_storage==="true"&&(masterData[`${props.field_option_src_context}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])){
                      setFieldOptions(masterData[`${props.field_option_src_context}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]);
                       
                    }
            else{
                let APIRES = await APIGET(props.field_option_src_context+`/`+props.field_option_src_critieria).then(
                (APIRES)=>{
                     
                    let responseArray =new Array();
                    let _i =0;
                    if(props.field_select_all_label){
                        let _obj = new Object();
                        _obj.option_label = props.field_select_all_label;
                        _obj.value = props.field_select_all_value;
                        responseArray[_i] = _obj;
                        _i++;  
                    }
                    Object.keys(APIRES.data).forEach( key => {
                        let _obj = new Object();
                        function checkType(lableData) {
                          if (typeof lableData === 'string') {
                            _obj.option_label = APIRES.data[key][lableData];
                            _obj.value = APIRES.data[key][props.field_option_value];
                          } else if (Array.isArray(lableData)) {
                            let label = "";
                            for (const item of lableData) {
                              if (item.column) {
                                label += APIRES.data[key][item.column];
                              } else if (item.string) {
                                label += item.string;
                              }
                            }
                            _obj.option_label = label
                          } else {
                            // It's neither a string nor an array.
                             
                          }
                        }   
                        function checkValueType(valueData) {
                          if (typeof valueData === 'string') {
                            _obj.value = APIRES.data[key][valueData];
      
                          } else if (Array.isArray(valueData)) {
                            let value = "";
                            for (const item of valueData) {
                              if (item.column) {
                                value += APIRES.data[key][item.column];
                              } else if (item.string) {
                                value += item.string;
                              }
                            }
                            _obj.value = value
                          } else {
                            // It's neither a string nor an array.
                             
                          }
                        }                      
                        checkType(props.field_option_label)
                        checkValueType(props.field_option_value)
                        // _obj.option_label = APIRES.data[key][props.field_option_label];
                        // _obj.value = APIRES.data[key][props.field_option_value];
                        _obj['attributes'] = {};
                        if(field_option_src.field_option_attributes){
                          field_option_src.field_option_attributes.map((att)=>{
                            _obj['attributes'][`data_${att}`]=APIRES.data[key][att];
                          });
                        }
                        responseArray[_i] = _obj;
                        _i++; 
                    })    
                    
                    const Options = responseArray.map(item => ({
                      ...item,
                      option_label: item.option_label === "" ? "Empty" : item.option_label,
                      value: item.value === "" ? " " : item.value
                  }));
                    console.log(responseArray)
                    setFieldOptions(Options);
                    
                    if(masterData[`${props.field_option_src_context}`&&`${props.field_option_src_context}`]){
                      if(masterData[`${props.field_option_src_context}`][`${field_id}`]){
                        masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = Options;
                      }
                      else{
                        masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                        masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = Options;
                      }
                    }
                    else{
                      masterData[`${props.field_option_src_context}`]={}
                      masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                      masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = Options;
                    }
                    // masterData[`${field_id}_${props.field_option_src_context}_${props.field_option_src_critieria}`] = responseArray;
                }
                );            
              }                  
        }
      } catch(err){/** TODO Do Nothing */}
    }
    useEffect(()=>{
      if(props.field_option_src.field_option_src_critieria){
        debouncedGetOptions(field_option_src);
      }
    },[field_option_src])

    useEffect(()=>{
      if(props.field_option_src.field_option_src_critieria){
      }else{
        setFieldOptions(field_options)
      }
    },[field_options])

    const field = {
        field_id:field_id,
        field_unique:field_unique,
        field_apipath:field_apipath,
        field_type:field_type,
        field_disabled:field_disabled,
        field_value:field_value,
        field_helperText:field_helperText,
        field_minlength:field_minlength,
        field_maxlength:field_maxlength,
        field_minvalue:field_minvalue,
        field_maxvalue:field_maxvalue,
        field_value_type:field_value_type,
        field_error_msg_required:field_error_msg_required,
        field_mandatory:field_mandatory,
        field_options: (fieldOptions) ? fieldOptions : field_options ,
        field_label:field_label
      }
      function handleBlur(){ 
        elementValidate(field)
      }
      function convertToNumberIfNumeric(str) {
        const parsedNumber = parseInt(str);
        return isNaN(parsedNumber) ? str : parsedNumber;
    }
      function handlingChange(_id,event,value){
        // let x = event.target;
        fieldOptions.map((option)=>{
          if(option.value === value && option.attributes){
            setAttr(option.attributes);
          }
        })
       const fieldValue = convertToNumberIfNumeric(value)
        handleChange(_id,{},value);
      }

useEffect(()=>{

  if(field_value&&fieldOptions){
    fieldOptions.map((option)=>{
      if(option.value === field_value && option.attributes){
        setAttr(option.attributes);
      }
    })
  }
},[field_value, fieldOptions]);

useEffect(()=>{
  if(typeof id==='number' && field_disabled_Edit==='yes' && field_value){
    setFieldDisable(true)
  }else{
    setFieldDisable(field_disabled)
  }
},[field_disabled, field_value]);

const handleClickOpen = () => {
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
};


    return (
          <div className={classes.inputroot}>
        <div style={{display:"flex"}}>
    <InputLabel className={classes.label}>{field_label}</InputLabel>{field_mandatory==="yes"?<span 
    style={{fontSize: "18px",
    color: "#d71729",
    fontWeight: "400",
    lineHeight: "20px",
    transform: "translateY(-2px)"}}>*</span>:null}
    </div>
        {/* <FormControl > */}
            
           <div className={classes.selectGrp}>
           <Selects className={classes.select}
             
             // name={name}
             id={field_id}
             {...attr}
             value={field_value}
             displayEmpty
             onChange={onChange || (event => handlingChange(field_id,event,event.target.value))}
             placeholder={field_placeholder}
             disabled={fieldDisable}
             onBlur={handleBlur}
             >
             {/* <MenuItem value="">{field_placeholder}</MenuItem> */}
             {field_placeholder?<MenuItem value="">{field_placeholder}</MenuItem>:null}

             {
                 fieldOptions.map(
                     (option,i) => ( 
                     (option.value)?
                     <MenuItem 
                             key={i} 
                             id={`${field_id}_op_${option.value}`}
                             {...option.attributes} 
                             value={option.value}
                             disabled={option.option_label==='Loading...'?true:false}
                     >
                         {option.option_label}
                     </MenuItem>
                     :
                     <MenuItem 
                         {...option.attributes}  
                         key={i}
                         value={option.option_label}
                     >
                         {option.option_label}
                     </MenuItem>
                     )
                 )
             }
         </Selects>
         {field_history==="yes"&&id&&<button className='hbtn' onClick={handleClickOpen}>History</button>}
           </div>
            <FormHelperText>{field_helperText}</FormHelperText>
        {/* </FormControl> */}
        {fields && <Dialog
          maxWidth='md'
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{fields.heading}</DialogTitle>
          <DialogContent>
            <SubTable fieldsData={fields.columns} apiPath={field_apipath} apiContextObj={apiContextObj} id={id} />
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </DialogContent>
        </Dialog>}
        </div>
    )
}

